import { inject } from "@angular/core";
import { CanMatchFn, RedirectCommand, Router } from "@angular/router";

import { AuthService } from "../../features/auth/services/auth/auth.service";

import { RbacService } from '../utils/services/rbac/rbac.service';
 
export const canMatchAuthGuard: CanMatchFn = (
    route,
    segments
) => {
    const authService = inject(AuthService);
    const rbacService = inject(RbacService);
    const router = inject(Router);
 
    if (!authService.isAuthenticated) {
        return new RedirectCommand(router.parseUrl('/login'));
    }

    if (segments.length === 0) {
        return true;
    }

    const currentRoute = route.children?.find((child) => child.path === segments[0].path);
    if (!currentRoute) {
        return true;
    }

    const currentRouteData = currentRoute.data;

    if (!currentRouteData) {
        return true;
    }

    const permission = currentRouteData['permission'];
    if (!permission) {
        return true;
    }

    if (!rbacService.hasPermission(permission)) {
        return new RedirectCommand(router.parseUrl('/dashboard'));
    }
    
    return true;
}